<template>
  <div id="app">
    <div id="nav" class="no-select">
      <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
      <header :class="headerClass">
        <router-link :to="{path:root}" class="logo">{{this.logo}}</router-link>
        <ul>
          <li v-for="(items,index) of list" :key="index">
            <router-link v-if="getLogo(items)" :to="{path:items.router}">{{items.hader_name}}</router-link>
          </li>
          <!-- <li><a href="http://word.yyyxuan.cn">爱背单词</a></li>-->
          <!-- <li><router-link to="/">Home</router-link></li>
          <li><router-link to="/about">About</router-link></li>
          <li><router-link to="/about">About</router-link></li>
          <li><router-link to="/about">About</router-link></li>
          <li><router-link to="/about">About</router-link></li> -->
        </ul>
      </header>
    </div>
    <router-view/>
    <div class="foot flex-row-center">
      <footer>
        <a href="https://beian.miit.gov.cn/">蜀ICP备19018990号</a>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  created(){
    this.fetch();
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  data(){
    return{
      scrolled:null,
      scrollnorm:null,
      innerWidth:null,
      headerClass:'',
      list:[],
      logo:'',
      root:''
    }
  },
  methods:{
    handleScroll () {
      if(window.scrollY > 0){
        this.headerClass="sticky";
      }else this.headerClass="";
      this.scrolled = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.innerWidth = document.documentElement.clientWidth || window.innerWidth;
      this.scrollnorm = document.documentElement.scrollTop / (document.documentElement.scrollHeight - document.documentElement.clientHeight);
      this.$store.commit('commitScrolled',this.scrolled);
      this.$store.commit('commitScrollnorm',this.scrollnorm);
      this.$store.commit('commitWidth',this.innerWidth);
      // console.log("页面"+this.innerWidth);
      // console.log("vuex中"+this.$store.state.scrollnorm);
    },
    async fetch(){
      const res = await this.$http.get('rest/header');
      if(!res.status==200){
        this.$message({
          type:'error',
          message:'请检查网络连接'
        })
        return;
      }
      this.list = res.data;
    },
    getLogo(i){
      if(i.iswebname == 1){
        this.logo=i.hader_name;
        this.root=i.router;
        return false;
      }else{return true}
    }
  }
}
</script>

<style lang="scss">
html,body{
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  font-family: Helvetica;
  color: #222;
}
ul,li {
  list-style: none;
}
h1,h2,h3,h4,h5,h6{
  margin: 0;
  padding: 0;
}
header{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: .6s;
  padding: 30px 0;
  z-index: 9999;
  will-change: scroll-position;
  @media screen and (max-width: 680px) {
    padding: 0px 0;
  }
  .logo{
    position: relative;
    font-weight: 700;
    color: #fff;
    text-decoration: none;
    font-size: 2em;
    text-transform: 2px;
    letter-spacing: 2px;
    transition: .6s;
    padding: 0 40px;
    @media screen and (max-width: 680px) {
      padding: 0 0px;
      font-size: 14px;
    }
    
  }
  ul{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 40px;
    li{
      position: relative;
      list-style: none;
    }
    a{
      position: relative;
      margin: 0 15px;
      text-decoration: none;
      color:#fff;
      letter-spacing: 2px;
      font-weight: 500;
      transition: .6s;
    }
  }
}
header.sticky{
  padding: 8px 0px;
  background: #fff;
  box-shadow: 0px 1px 2px 1px  #999;
  a{
    color: #000;
  }
}
.foot{
  width: 100%;
  height: 10vh;
  bottom: 0;
  z-index: 9998;
  background: #555;
  footer a{
    font-size: 30px;
    color: #fff;
    text-decoration:none; 
  }
}
.flex-row-center{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.flex-row-around{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.flex-column-center{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.flex-column{
  display: flex;
  flex-direction: column;
}
.span-h1{
    font-size: 2em;
    -webkit-margin-before: 0.67em;
    -webkit-margin-after: 0.67em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    font-weight: bold;
}
.span-h2{
    font-size: 1.5em;
    -webkit-margin-before: 0.83em;
    -webkit-margin-after: 0.83em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    font-weight: bold;
}
.span-h3{
    font-size: 1.17em;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    font-weight: bold;
}
.image-size{
  width: 100%;
  height: auto;
  border-radius: 5px;
}
.clear{
  margin: 0;
  padding: 0;
}
.no-select{
  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}
</style>
